import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/services/auth.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { OrganisationApiService } from '@shared/services/organisation-api.service';
import { catchError, map, of } from 'rxjs';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { LoaderComponent } from "@shared/components/commons/loader/loader.component";
import { getAnnualStatementsPath, getGenerateDocumentPath } from '../../../../shared/utils/route-path-utils';

@Component({
  selector: 'app-redirect.esign',
  standalone: true,
  imports: [
    RouterLink,
    LoaderComponent
  ],
  templateUrl: 'redirect-e-sign-page.component.html',
  styleUrl: 'redirect-e-sign-page.component.scss'
})
export class RedirectESignPageComponent implements OnInit {
  authService = inject(AuthService);
  organisationService = inject(OrganisationApiService);
  route = inject(ActivatedRoute);
  sanitizer = inject(DomSanitizer);
  destroyRef = inject(DestroyRef);

  readonly successMessage = 'Envelope signed successfully';
  readonly declinedMessage = 'Envelope declined';

  isAuthorized!: boolean;
  documentId = '';
  logoUrl: SafeUrl | null = null;
  isDocument = true;
  message = '';

  ngOnInit(): void {
    this.isAuthorized = this.authService.isAuthenticated;
    this.route.queryParamMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((queryParamMap) => {
        const isDocumentParam = queryParamMap.get('isDocument');
        this.isDocument = !!isDocumentParam && isDocumentParam.toLocaleLowerCase() === 'true';

        const declinedParam = queryParamMap.get('declined');
        this.message = declinedParam && declinedParam === 'true'
          ? this.declinedMessage
          : this.successMessage;
      });

    this.documentId = this.route.snapshot.paramMap.get('id') ?? '';

    if (this.documentId) {
      this.fetchLogo(this.documentId);
    } else {
      void this.authService.login();
    }
  }

  fetchLogo(documentId: string): void {
    this.organisationService
      .getSmallLogByDocumentId(documentId)
      .pipe(
        map((blob) => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob))),
        catchError(() => {
          console.error('Failed to load the large logo. Falling back to default.');
          return of('assets/svg/pravo-logo-midnight.svg');
        })
      )
      .subscribe((logoUrl) => {
        this.logoUrl = logoUrl;
      });
  }

  get documentPath(): string[] {
    return this.isDocument
      ? getGenerateDocumentPath(this.documentId)
      : getAnnualStatementsPath(this.documentId);
  }
}
